// @flow
import React from 'react';
import Avatar from '@atlaskit/avatar';
import * as utils from 'chronos-utils';

import type {
  Issue,
  Epic,
  User,
  Project,
} from 'chronos-types';

import {
  Col,
} from '../styled';
import {
  ListRow,
  ListRowBody,
  Info,
  FakeItem,
  Summary,
  Key,
  Total,
  ItemImg,
  AvatarWrap,
} from './styled';


type Item = Issue | Epic | User | Project;

function randomInt(min, max) {
  return Math.round((Math.random() * (max - min)) + min);
}

function getAvatar(item) {
  const placeholder = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  if (!item.avatarUrls) return placeholder;

  return item.avatarUrls['48x48'] || placeholder;
}

function isSelected(selectedRows, item) {
  if (!item) return false;
  return selectedRows.includes(item.id);
}

type Props = {
  item: Item,
  style: Object,
  groupBy: string,
  index: number,
  fetching: boolean,
  selectedRows?: Array<string>,
  highlighted: boolean,
  selectRows: { (): void },
};

const ListRowRenderer = ({
  item,
  style,
  groupBy,
  index,
  fetching,
  selectedRows,
  highlighted,
  selectRows,
}: Props) => {
  const selected = isSelected(selectedRows, item);
  return (
    <ListRow
      style={style}
      selected={selected || highlighted}
      onClick={e => selectRows(item.id, e)}
    >
      {item ? (
        <ListRowBody>
          {groupBy === 'issues' && (
            <Info>
              <Col size="60%">
                {
                  item.fields?.priority?.iconUrl
                  && (
                    <ItemImg src={item.fields.priority.iconUrl} />
                  )
                }
                {
                  item.fields?.issuetype?.iconUrl
                  && (
                    <ItemImg src={item.fields.issuetype.iconUrl} />
                  )
                }
                <Summary>{item.fields.summary}</Summary>
              </Col>
              <Col size="20%">
                <Key>{item.key}</Key>
              </Col>
              <Col size="100px">
                <Total>{utils.getTotalTimeLogged(item.fields.worklog)}</Total>
              </Col>
            </Info>
          )}
          {groupBy === 'users' && (
            <Info>
              <Col size="60%">
                <AvatarWrap>
                  <Avatar
                    size="small"
                    src={getAvatar(item)}
                  />
                </AvatarWrap>
                <Summary>
                  {item.displayName}
                </Summary>
              </Col>
              <Col size="20%">
                <Key>{item.key}</Key>
              </Col>
              <Col size="100px">
                <Total>
                  {utils.stj(item.totalTimeSeconds)}
                </Total>
              </Col>
            </Info>
          )}
          {groupBy === 'projects' && (
            <Info>
              <Col size="60%">
                <AvatarWrap>
                  <Avatar
                    size="small"
                    src={getAvatar(item)}
                  />
                </AvatarWrap>
                <Summary>
                  {item.name}
                </Summary>
              </Col>
              <Col size="20%">
                <Key>{item.key}</Key>
              </Col>
              <Col size="100px">
                <Total>
                  {utils.stj(item.totalTimeSeconds)}
                </Total>
              </Col>
            </Info>
          )}
        </ListRowBody>
      ) : (
        <ListRowBody>
          {fetching && (
            <Info>
              <Col size="60%">
                <FakeItem space size="16px" delay={`0.${index}s`} />
                <FakeItem space size="16px" delay={`0.${index}s`} />
                <FakeItem
                  space
                  size={`${randomInt(45, 60)}%`}
                  delay={`0.${index}s`}
                />
              </Col>
              <Col size="20%">
                <FakeItem size="80%" delay={`0.${index}s`} />
              </Col>
              <Col size="100px">
                <FakeItem size="40px" delay={`0.${index}s`} />
              </Col>
            </Info>
          )}
        </ListRowBody>
      )}
    </ListRow>
  );
};

ListRowRenderer.defaultProps = {
  selectedRows: [],
};

export default ListRowRenderer;
